import { useEffect, useState } from "react";
import { useQuestionizerStore } from "../types/state.ts";
import { FDWAntragsteller, FDWResultEntry } from "restfd2";
import Checkbox from "./checkbox.tsx";
import LoadingIndicator from "./loading-indicator.tsx";
import Input from "./input.tsx";
import { DoiForm, LeadForm } from "./lead_form.tsx";

export function QuestionizerResultSummary(){
    const plz = useQuestionizerStore((state) => state.plz);
    const gemeinde = useQuestionizerStore((state) => state.gemeinde);
    const gewerk_labels = useQuestionizerStore((state) => state.getGewerkLabels());
    const gebaeude = useQuestionizerStore((state) => state.gebaeude);
    const typ = useQuestionizerStore((state) => state.typ);
    const baujahr = useQuestionizerStore((state) => state.baujahr);
    const antragsteller = useQuestionizerStore((state) => state.antragsteller);
    const antragsteller_detail = useQuestionizerStore((state) => state.antragsteller_detail);
	const L = useQuestionizerStore((state) => state.L);

    const _antragsteller = (antragsteller?.length == 1) ? antragsteller[0] : antragsteller_detail;

    //console.log("LABELS:",gewerk_labels);
    
	return (
		  <div className="mb-8"  aria-describedby="result-summary">

			<p id="result-summary" className="mb-8">{L("result-summary-description")}</p>

			<section className="summary">
			  <h2 className="summary__title">{L("result-summary-title")}</h2>

			  {/* Barrierefreie Tabelle */}
			  <table className="summary__table" style={{ borderCollapse: "collapse" }}>
				<caption className="sr-only">{L("result-summary-title")}</caption>

				<tbody>
				  <tr>
					<th scope="row" style={{ textAlign: "left", verticalAlign: "top" }}>
					  Gewählte Maßnahmen
					</th>
					<td>{gewerk_labels.join(", ")}</td>
				  </tr>

				  <tr>
					<th scope="row" style={{ textAlign: "left", verticalAlign: "top" }}>
					  Antragsteller
					</th>
					<td>{FDWAntragsteller[_antragsteller!]}</td>
				  </tr>

				  <tr>
					<th scope="row" style={{ textAlign: "left", verticalAlign: "top" }}>
					  Ort
					</th>
					<td>{plz} {gemeinde?.gemeinde_name}</td>
				  </tr>

				  <tr>
					<th scope="row" style={{ textAlign: "left", verticalAlign: "top" }}>
					  Gebäude
					</th>
					<td>{gebaeude}</td>
				  </tr>

				  <tr>
					<th scope="row" style={{ textAlign: "left", verticalAlign: "top" }}>
					  Typ
					</th>
					<td>{typ}</td>
				  </tr>

				  <tr>
					<th scope="row" style={{ textAlign: "left", verticalAlign: "top" }}>
					  Baujahr
					</th>
					<td>{baujahr}</td>
				  </tr>
				</tbody>
			  </table>
			</section>
		  </div>
		);

 
  }